import { MetalsTask } from "../models/metals-task.model";
import { findRootTasks } from "./find-root-tasks.function";

export function getLinearTaskOrder(tasks: MetalsTask[]): MetalsTask[] | null {
    if (tasks.length === 0) return null;

    const roots = findRootTasks(tasks);
    if (roots.length !== 1) return null;

    const taskDict = new Map<string, MetalsTask>();
    tasks.forEach(t => taskDict.set(t.id, t));

    const ordered: MetalsTask[] = [];
    const visited = new Set<string>();
    let current: MetalsTask | undefined = roots[0];

    while (current && !visited.has(current.id)) {
        visited.add(current.id);
        ordered.push(current);
        current = current.nextTaskId ? taskDict.get(current.nextTaskId) : undefined;
    }

    if (ordered.length !== tasks.length) return null;
    return ordered;
}
